module.exports = __webpack_public_path__ + "img/banner_icon_2.93cbe7ce.png";